import type { EntryFormValues } from "../types";

export type EntryFormErrors = Partial<Record<keyof EntryFormValues, string>>;

export function normalizeEmail(value: string): string {
  return value.trim().toLowerCase();
}

export function validateEntryForm(values: EntryFormValues): EntryFormErrors {
  const errors: EntryFormErrors = {};
  const email = normalizeEmail(values.email);

  if (!values.firstName.trim() || values.firstName.trim().length > 80) {
    errors.firstName = "Enter your first name.";
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.length > 320) {
    errors.email = "Enter a valid email address.";
  }
  if (!values.ageAndResidenceConfirmed) {
    errors.ageAndResidenceConfirmed = "Confirm you are 18 or over and live in Victoria.";
  }
  if (values.website) {
    errors.website = "Unable to submit this entry.";
  }

  return errors;
}
